import type { MetricValue } from "@broadview/api-client";

const currencyMetrics = new Set([
  "K007",
  "K008",
  "K009",
  "K010",
  "K011",
  "K012",
  "K013",
  "K016",
  "K017",
  "K022",
  "K030",
  "K045",
  "K049",
  "K050",
  "K054",
  "K055",
  "K056",
  "K057",
  "K058",
  "K060",
  "K061",
]);

const percentMetrics = new Set([
  "K014",
  "K015",
  "K021",
  "K027",
  "K032",
  "K043",
  "K044",
  "K046",
  "K062",
  "K068",
  "K069",
  "K074",
  "K076",
]);

function inferredUnit(metric: MetricValue): string | undefined {
  if (metric.unit) return metric.unit.toLowerCase();
  if (currencyMetrics.has(metric.definitionId)) return "usd";
  if (percentMetrics.has(metric.definitionId)) return "percent";
  if (metric.definitionId === "K006" || metric.definitionId === "K072") return "days";
  if (metric.definitionId === "K019") return "claims_per_1000";
  if (metric.definitionId === "K052") return "rate";
  if (metric.definitionId === "K073") return "hours";
  if (["K020", "K023", "K024", "K025"].includes(metric.definitionId)) return "decimal";
  return undefined;
}

function number(value: number, maximumFractionDigits: number, minimumFractionDigits = 0) {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(value);
}

export function formatMetricDisplayValue(metric: MetricValue): string {
  const value =
    typeof metric.value === "number"
      ? metric.value
      : typeof metric.value === "string" && /^[+-]?(?:\d+(?:\.\d+)?|\.\d+)$/.test(metric.value)
        ? Number(metric.value)
        : undefined;
  if (value === undefined || !Number.isFinite(value)) return metric.displayValue;

  const unit = inferredUnit(metric);
  if (unit === "usd") {
    const fractionDigits = Number.isInteger(value) ? 0 : 2;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(value);
  }
  if (unit === "percent") return `${number(value, 1)}%`;
  if (unit === "rate") return `${number(value * 100, 2)}%`;
  if (unit === "days") return `${number(value, 1)} ${value === 1 ? "day" : "days"}`;
  if (unit === "hours") return `${number(value, 1)} ${value === 1 ? "hour" : "hours"}`;
  if (unit === "claims_per_1000") return `${number(value, 3)} / 1,000`;
  if (unit === "decimal") return number(value, 3);

  return number(value, 1);
}
